import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { PaymentRoutingModule } from './payment-routing.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FormsModule } from '@angular/forms';
import { MakepaymentComponent } from './makepayment/makepayment.component';
import { PayreceiptComponent } from './payreceipt/payreceipt.component';
import { QRCodeModule } from 'angularx-qrcode';
import {SharedModule} from '../shared/shared.module';
import { PaymentfailedComponent } from './paymentfailed/paymentfailed.component';
import { PendingComponent } from './pending/pending.component';
import { RefundComponent } from './refund/refund.component';
//import { EChallanComponent } from './echallan/echallan.component'

@NgModule({
  imports: [
    CommonModule,
    PaymentRoutingModule,
    MyDatePickerModule,
    FormsModule,
    NgZorroAntdModule.forRoot(),
    QRCodeModule,
    SharedModule
  ],
  declarations: [MakepaymentComponent, PayreceiptComponent, PaymentfailedComponent, PendingComponent, RefundComponent]
})
export class PaymentModule { }
